export enum DelimiterType {
  SETTINGS_EXPORTDELIMITER_OPTION_COMMA = ',',
  SETTINGS_EXPORTDELIMITER_OPTION_SEMICOLON = ';',
  SETTINGS_EXPORTDELIMITER_OPTION_TAB = '\t',
  SETTINGS_EXPORTDELIMITER_OPTION_PIPE = '|',
  SETTINGS_EXPORTDELIMITER_OPTION_EXCLAMATION = '!',
}
